export function sanitizeHTML(s) {
    return s ? s.replace(/(<([^>]+)>)/ig, '') : s;
}
